// Reuse the admin palette and light/dark surfaces for all six parts of the flow workspace.
export const ADMIN_FLOW_PANEL = "rounded border border-greyscale-20 bg-white dark:border-gray-700 dark:bg-gray-800";
export const ADMIN_FLOW_INPUT =
  "w-full select-text rounded border border-greyscale-20 bg-transparent px-3 py-2 text-sm dark:border-gray-600";
export const ADMIN_FLOW_BUTTON =
  "inline-flex items-center justify-center gap-2 rounded border border-greyscale-20 px-3 py-2 text-sm font-medium transition-colors hover:bg-greyscale-10 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-600 dark:hover:bg-gray-700";
export const ADMIN_FLOW_PRIMARY = `${ADMIN_FLOW_BUTTON} border-transparent bg-green text-white hover:bg-[#166b60] dark:hover:bg-[#166b60]`;
export const ADMIN_FLOW_NODE_LABELS = {
  source: "Data source",
  agent: "AI step",
  merge: "Merge inputs",
  text: "Text output",
  email: "Email draft",
} as const;
export const ADMIN_FLOW_VIEWS = [
  { id: "whiteboard", label: "Whiteboard" },
  { id: "cards", label: "New Flow wizard" },
  { id: "auto", label: "Auto builder" },
  { id: "schedule", label: "Schedule" },
  { id: "history", label: "History" },
  { id: "review", label: "Review Run" },
] as const;
